import React from 'react';
import { View } from 'react-native';

interface FormFooterSpacerProps {
  headerHeight?: number;
  bottomInset?: number;
  keyboardHeight?: number;
  extraSpacing?: number;
}

const FormFooterSpacer: React.FC<FormFooterSpacerProps> = ({
  headerHeight = 0,
  bottomInset = 0,
  keyboardHeight = 0,
  extraSpacing = 0,
}) => {
  const baseSpacing = Math.max(0, bottomInset + headerHeight + extraSpacing);
  const keyboardSpacer = Math.max(0, keyboardHeight - bottomInset);

  return (
    <>
      {baseSpacing > 0 && <View style={{ height: baseSpacing }} />}
      {keyboardHeight > 0 && keyboardSpacer > 0 && <View style={{ height: keyboardSpacer }} />}
    </>
  );
};

export default FormFooterSpacer;
